import { Swal } from 'larasnap/support';
import { getAppData, getAppConfig } from 'larasnap';

export const showError = (error, statusCode) => {
    if (getAppConfig('debug')) {
        showDebugError(error);
    } else {
        showFriendlyError(error, statusCode);
    }
};

const showFriendlyError = (error, statusCode) => {
    const email = getAppConfig('support_email');
    const errorMessage = getAppConfig(`errors.${statusCode}.message`);
    const contactMessage = getAppConfig('errors.contact_message').replace(
        ':email',
        `<a href="mailto:${email}">${email}</a>`,
    );

    Swal.fire({
        icon: 'error',
        html: errorMessage,
        footer: `<div>${contactMessage}</div>`,
    });
};

const showDebugError = error => {
    if (typeof error === 'string') {
        Swal.fire({
            html: error,
        });
    } else {
        const { exception, message, file, line, trace } = error;
        const html = [];

        const formatTraceEntry = ({ file, line }) => {
            const entry = String(file).replace(getAppData('base_path'), '');
            return `<div>${entry} <strong>${line}</strong></div>`;
        };

        if (exception) {
            html.push(`<h2>${exception}</h2>`);
        }
        if (message) {
            html.push(`<h2>${message}</h2>`);
        }
        if (file) {
            html.push(`<div>${file} <strong>${line}</strong></div>`);
        }
        if (trace) {
            const traceArray = Array.isArray(trace) ? trace : Object.values(trace);
            const traceHtml = traceArray.map(formatTraceEntry).join('');
            html.push(`<h3>Backtrace</h3> ${traceHtml}`);
        }

        Swal.fire({
            width: 1100,
            html: `<div class="text-left">${html.join('')}</div>`,
        });
    }
};
